<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_8.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">A</div>
				<div class="step_txt">
					<div>
						Remove the swab from the pouch.
					</div>
					<div class="txt_note">
						Note: Be careful not to touch the swab tip (soft end) with hand.
					</div>
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/step_9.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">B</div>
				<div class="step_txt">
					<ul>
						<li>
							Carefully insert the swab tip into one nostril about
							<span class="col-red">1/2</span> to <span class="col-red">3/4 inch</span>. &nbsp;Firmly and slowly rotate the swab 5 times, &nbsp;
							brushing against the inside walls of the nostril to ensure 
							both mucus and cells are collected.
							<div class="" style="padding-top: 0.12rem;">
								Do not push the swab further if you meet resistance.<br />
								<span class="col-red">For young children do not insert more than 1/2 inch.</span>
							</div>
						</li>
						<li>
							Using the <span class="col-red">same swab</span>, &nbsp;repeat this process for the
							other nostril to ensure an adequate sample is collected 
							from both nostrils.
						</li>
					</ul>
					<div class="txt_note">
						Note: Failure to swab properly may cause incorrect results.
					</div>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goStepFour"
			>
				Next
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			//
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		//
	},
	mounted() {
		this.$router.afterEach((to, from, next) => {
			window.scrollTo(0, 0);
		})
	},
	watch: {
		//
	},
	methods: {
		goStepFour() {
			this.$router.push({path:'/stepfour'});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100%;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}

.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{padding:0rem 0.9rem 1.107rem 0.9rem;}
.step_box img, .btn_box img{width: 100%;}

.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
.step_txt .txt_note{
	padding-top: 0.427rem;
	color: #720000;
	font-weight: bold;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}


>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}
</style>
